"use client";
import { useCurrency } from "@/app/providers/currencyContext";

export interface CartItemPriceProps {
  price: number;
}

export const CartItemPrice = ({ price }: CartItemPriceProps) => {
  const { format } = useCurrency();

  return <p className="text-[16px] font-medium mt-0.5">{format(price)}</p>;
};
